/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Region_South_America_DescriptionInputs */

const bn_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্পূর্ণ দক্ষিণ আমেরিকা অঞ্চল।`)
};

const de_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die gesamte südamerikanische Region.`)
};

const el_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ολόκληρη η περιοχή της Νότιας Αμερικής.`)
};

const en_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The complete South American region.`)
};

const es_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La región sudamericana completa.`)
};

const fr_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La région complète de l’Amérique du Sud.`)
};

const hi_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपूर्ण दक्षिण अमेरिकी क्षेत्र.`)
};

const hu_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A teljes dél-amerikai régió.`)
};

const id_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wilayah Amerika Selatan yang lengkap.`)
};

const it_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'intera regione del Sud America.`)
};

const ja_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全な南米地域。`)
};

const ko_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`남미 전체 지역.`)
};

const nl_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De volledige Zuid-Amerikaanse regio.`)
};

const pl_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cały region Ameryki Południowej.`)
};

const pt_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A região sul-americana completa.`)
};

const ru_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Весь регион Южной Америки.`)
};

const sv_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hela sydamerikanska regionen.`)
};

const tr_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam Güney Amerika bölgesi.`)
};

const uk_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повний регіон Південної Америки.`)
};

const vi_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn bộ khu vực Nam Mỹ.`)
};

const zh_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整的南美洲地区。`)
};

const zh_hant_intro_region_south_america_description = /** @type {(inputs: Intro_Region_South_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整的南美洲地區。`)
};

/**
* | output |
* | --- |
* | "The complete South American region." |
*
* @param {Intro_Region_South_America_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_region_south_america_description = /** @type {((inputs?: Intro_Region_South_America_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Region_South_America_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_region_south_america_description(inputs)
	if (locale === "de") return de_intro_region_south_america_description(inputs)
	if (locale === "el") return el_intro_region_south_america_description(inputs)
	if (locale === "en") return en_intro_region_south_america_description(inputs)
	if (locale === "es") return es_intro_region_south_america_description(inputs)
	if (locale === "fr") return fr_intro_region_south_america_description(inputs)
	if (locale === "hi") return hi_intro_region_south_america_description(inputs)
	if (locale === "hu") return hu_intro_region_south_america_description(inputs)
	if (locale === "id") return id_intro_region_south_america_description(inputs)
	if (locale === "it") return it_intro_region_south_america_description(inputs)
	if (locale === "ja") return ja_intro_region_south_america_description(inputs)
	if (locale === "ko") return ko_intro_region_south_america_description(inputs)
	if (locale === "nl") return nl_intro_region_south_america_description(inputs)
	if (locale === "pl") return pl_intro_region_south_america_description(inputs)
	if (locale === "pt") return pt_intro_region_south_america_description(inputs)
	if (locale === "ru") return ru_intro_region_south_america_description(inputs)
	if (locale === "sv") return sv_intro_region_south_america_description(inputs)
	if (locale === "tr") return tr_intro_region_south_america_description(inputs)
	if (locale === "uk") return uk_intro_region_south_america_description(inputs)
	if (locale === "vi") return vi_intro_region_south_america_description(inputs)
	if (locale === "zh") return zh_intro_region_south_america_description(inputs)
	return zh_hant_intro_region_south_america_description(inputs)
});